
import {
  questions,
  solotionTabItems,
  PopularServices,
  scrubbingCenter,
  cdnCoverage,
  serviceFeatures,
  features,
} from "../../data/secureWorkspace";
import Modal from "../../components/rebranding/modal/Modal.vue";

export default {
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      solotionTabItems,
      questions,
      PopularServices,
      serviceFeatures,
      features,
      scrubbingCenter,
      cdnCoverage,
      activeSection: "",
      tab: 0,
      solotionTab: 0,
    };
  },
  components: {
    Modal,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  head() {
    return {
      title: "فضای کاری امن آبالون |‌ دسترسی کنترل‌شده سازمانی",
      meta: [
        {
          name: "description",
          content:
            "پلتفرم Secure WorkSpace آبالون | دسترسی ایمن و کنترل‌شده کاربران به منابع سازمانی |‌ ثبت تصویری و نظارت کامل بر فعالیت‌ها | اعطای مجوز‌های موقت",
        },
        {
          name: "keywords",
          content:
            "فضای کاری امن, فضای کاری امن آبالون, Secure Workspace آبالون",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/secure-workspace",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "فضای کاری امن آبالون |‌ دسترسی کنترل‌شده سازمانی",
        },
        {
          property: "og:description",
          content:
            "پلتفرم Secure WorkSpace آبالون | دسترسی ایمن و کنترل‌شده کاربران به منابع سازمانی |‌ ثبت تصویری و نظارت کامل بر فعالیت‌ها | اعطای مجوز‌های موقت",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/secure-workspace",
        },
        {
          name: "twitter:title",
          title: "فضای کاری امن آبالون |‌ دسترسی کنترل‌شده سازمانی",
        },
        {
          name: "twitter:description",
          content:
            "پلتفرم Secure WorkSpace آبالون | دسترسی ایمن و کنترل‌شده کاربران به منابع سازمانی |‌ ثبت تصویری و نظارت کامل بر فعالیت‌ها | اعطای مجوز‌های موقت",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/secure-workspace",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "پلتفرم فضای کاری امن آبالون چه کاربردی برای سازمان‌ها دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "این پلتفرم دسترسی کاربران به سامانه‌ها و منابع سازمانی را به‌صورت کاملاً ایزوله، کنترل‌شده و امن فراهم می‌آورد، به‌گونه‌ای که کاربران بدون ارتباط مستقیم با زیرساخت، صرفاً از طریق یک فضای کاری امن (بر پایه مرورگر) به محیط کاری خود متصل می‌شوند.",
                },
              },
              {
                "@type": "Question",
                name: "تفاوت فضای کاری امن آبالون با VPN برای اتصال به سازمان چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "در معماری این پلتفرم، برخلاف VPN، کاربر به‌صورت غیرمستقیم و ایزوله به منابع متصل می‌شود. تمام مسیرها، سیاست‌ها و رمزها در پشت‌صحنه مدیریت می‌شوند و مرورگر تنها نقش نمایشگر را دارد.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان کنترل و نظارت بر فعالیت کاربران وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. تمامی فعالیت‌های کاربران در فضای کاری امن آبالون، پس از احراز هویت، هنگام اتصال به منابع سازمانی ثبت و ضبط می‌شوند. این اطلاعات قابل ارسال به سامانه‌های تحلیل امنیتی مانند SIEM نیز هستند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا کاربران خارج از سازمان یا پیمانکاران هم می‌توانند از این پلتفرم استفاده کنند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. با توجه به احراز هویت چندمرحله‌ای و معماری Zero Trust، این پلتفرم دسترسی امن برای کاربران برون‌سازمانی، پیمانکاران و حتی کارکنان دورکار را به‌شکل کاملاً کنترل‌شده فراهم می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "مزیت اصلی پلتفرم فضای کاری امن آبالون نسبت به راهکارهای سنتی چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "این پلتفرم نیازی به VPN یا نصب نرم‌افزار ندارد، تجربه‌ای روان و یکپارچه در مرورگر فراهم می‌کند، مستقل از محل اتصال یا دستگاه کاربر، کار می‌کند و امکان نظارت دقیق و مستندسازی کامل را برای مدیران امنیتی فراهم می‌سازد.",
                },
              },
            ],
          },
        },
      ],
    };
  },
};
